import React from 'react';
import { motion } from 'framer-motion';

const sectionVariants = {
  hidden: { opacity: 0, y: 50 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: "easeOut"
    }
  }
};

const AboutPage: React.FC = () => {
  return (
    <div className="relative overflow-hidden" style={{
      background: 'linear-gradient(to bottom, #141019, #1A1625)',
    }}>
      <div className="absolute inset-0 bg-[url('https://grainy-gradients.vercel.app/noise.svg')] opacity-[0.03]"></div>
      <div className="absolute top-0 right-0 w-96 h-96 bg-purple-500/10 blur-[150px] rounded-full"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-pink-500/10 blur-[150px] rounded-full"></div>

      <div className="container mx-auto py-12 px-4 relative z-10">
        <div className="max-w-5xl mx-auto">
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="text-4xl md:text-5xl font-bold mb-8 text-white"
          >
            About DevMarket
          </motion.h1>

          <motion.div
            initial="hidden"
            animate="visible"
            variants={sectionVariants}
            className="bg-gradient-to-r from-[#1F1A27] to-[#2A1E44] rounded-lg shadow-lg p-8 mb-12 border border-white/5"
          >
            <h2 className="text-2xl font-semibold mb-4 text-white">Our Mission</h2>
            <p className="text-white/80 mb-6">
              At DevMarket, we're committed to empowering developers with the tools, resources, and
              products they need to build amazing software. Our platform brings together the best
              development tools, libraries, and services in one place, making it easier for
              developers to discover and implement solutions for their projects.
            </p>

            <h2 className="text-2xl font-semibold mb-4 text-white">Our Story</h2>
            <p className="text-white/80 mb-6">
              Founded in 2023 by a group of passionate developers, DevMarket was born out of the
              frustration of searching across multiple platforms for development resources. We
              believed there had to be a better way to connect developers with the tools they need,
              so we created a marketplace specifically designed for the developer community.
            </p>

            <h2 className="text-2xl font-semibold mb-4 text-white">Our Values</h2>
            <ul className="list-disc pl-6 text-white/80 mb-6">
              <li className="mb-2"><span className="font-semibold text-[#F670C7]">Quality:</span> We curate only the best development tools and resources.</li>
              <li className="mb-2"><span className="font-semibold text-[#F670C7]">Community:</span> We believe in the power of developers helping developers.</li>
              <li className="mb-2"><span className="font-semibold text-[#F670C7]">Innovation:</span> We continuously improve our platform based on developer feedback.</li>
              <li className="mb-2"><span className="font-semibold text-[#F670C7]">Accessibility:</span> We make advanced development tools accessible to everyone.</li>
            </ul>
          </motion.div>

          <motion.div
            initial="hidden"
            animate="visible"
            variants={sectionVariants}
            className="bg-gradient-to-r from-[#1F1A27] to-[#2A1E44] rounded-lg shadow-lg p-8 border border-white/5"
          >
            <h2 className="text-2xl font-semibold mb-4 text-white">Our Team</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {[
                { name: 'Alex Johnson', role: 'Founder & CEO', image: 'https://via.placeholder.com/150' },
                { name: 'Sam Taylor', role: 'CTO', image: 'https://via.placeholder.com/150' },
                { name: 'Jamie Smith', role: 'Head of Product', image: 'https://via.placeholder.com/150' },
              ].map((member, index) => (
                <div key={index} className="text-center">
                  <img src={member.image} alt={member.name} className="w-32 h-32 rounded-full mx-auto mb-4 border-2 border-[#F670C7]" />
                  <h3 className="font-semibold text-lg text-white">{member.name}</h3>
                  <p className="text-white/60">{member.role}</p>
                </div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
